import { get } from "lodash";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { Header, Loader, Message, Pagination } from "semantic-ui-react";

import { RegistriesApiService } from "./../../api";

import { RegistryTable } from "./components";

const Registry = ({
  activePage,
  columns,
  isLoading,
  notFoundError,
  onPageChange,
  registry,
  totalPages,
  rows,
}) => {
  return (
    <Fragment>
      {registry && <Header as="h3">{get(registry, "name")}</Header>}
      {isLoading && (
        <Loader active={true} content="Ładowanie danych..." inline="centered" />
      )}
      {registry &&
        !isLoading &&
        (rows.length > 0 ? (
          <RegistryTable columns={columns} rows={rows} />
        ) : (
          <Message
            content="Brak wpisów w rejestrze."
            header="Brak wyników"
            icon="frown"
          />
        ))}
      {totalPages > 1 && (
        <Pagination
          activePage={activePage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      )}
      {notFoundError && (
        <Message
          content="Nie znaleziono rejestru."
          error
          header="Wystąpił błąd"
          icon="warning sign"
        />
      )}
    </Fragment>
  );
};

Registry.propTypes = {
  activePage: PropTypes.number,
  columns: PropTypes.array,
  isLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  pageCount: PropTypes.number,
  rows: PropTypes.array,
};

Registry.defaultProps = {
  activePage: 1,
  columns: [],
  onPageChange: () => {},
  totalPages: 1,
  rows: [],
};

const enhance = compose(
  withState("activePage", "setActivePage", 1),
  withState("columns", "setColumns", []),
  withState("isLoading", "setLoading", true),
  withState("notFoundError", "setNotFoundError", false),
  withState("registry", "setRegistry"),
  withState("totalPages", "setTotalPages", 1),
  withState("rows", "setRows", []),
  withHandlers({
    onPageChange: ({ match, setActivePage, setLoading, setRows }) => async (
      e,
      { activePage }
    ) => {
      setActivePage(activePage);
      setLoading(true);
      try {
        const { registry: registryId } = match.params;
        const { organization: organizationId } = match.params;
        const { rows } = await RegistriesApiService.getRegistry(
          registryId,
          organizationId,
          activePage - 1
        );
        setRows(rows);
      } finally {
        setLoading(false);
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      const registryId = get(this.props, "match.params.registry");
      const organizationId = get(this.props, "match.params.organization");
      this.props.setLoading(true);
      try {
        const {
          columns,
          registry,
          rows,
          totalCount,
        } = await RegistriesApiService.getRegistry(registryId, organizationId);
        this.props.setColumns(columns);
        this.props.setRegistry(registry);
        this.props.setRows(rows);
        const totalPages = Math.ceil(totalCount / rows.length);
        this.props.setTotalPages(totalPages);
      } catch (error) {
        this.props.setNotFoundError(true);
      } finally {
        this.props.setLoading(false);
      }
    },
  })
);

export default enhance(Registry);



// WEBPACK FOOTER //
// ./src/containers/registry/Registry.js